import { useConfig } from '@hooks/useConfig';
import { useQuery } from '@tanstack/react-query';
import { axios } from 'lib';
import { toast } from 'react-toastify';

export const useUsersData = () => {
  const config = useConfig();
  const fetchUsers = async () => {
    try {
      const response = await axios.get('/admin-dashboard/all-students', config);
      return response.data.students;
    } catch (error) {
      throw error;
    }
  };

  const { data: studentsList, isFetching: loadingStudentsList } = useQuery({
    queryKey: ['user-list'],
    queryFn: fetchUsers,
    onError: (err) =>
      toast.error(
        typeof err === 'string'
          ? err
          : 'Something went wrong fetching status list'
      ),
  });

  return [{ studentsList, loadingStudentsList }];
};

export const useUserDetail = (id: any) => {
  const config = useConfig();
  const fetchStudentsDetail = async (id: any) => {
    try {
      const response = await axios.get(`/student/show/${id}`, config);
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  const { data: users, isFetching: loadingUsers } = useQuery({
    queryKey: ['student-detail', id],
    queryFn: () => fetchStudentsDetail(id),
    onError: (err) =>
      toast.error(
        typeof err === 'string'
          ? err
          : 'Something went wrong fetching status list'
      ),
  });

  return [{ users, loadingUsers }];
};
